type Strings = Array<string | undefined | null>;

export type JoinOptions = {
  fallback?: string;
  separator?: string;
};

export function joinStringWithFallback(
  strings: Strings,
  options?: JoinOptions
): string {
  const { fallback = '', separator = ' ' } = options ?? {};

  return strings.filter(Boolean).join(separator).trim() || fallback;
}
